export default __webpack_public_path__ + "static/media/ashland.bb30e168.png";